
import React from 'react';
import { BarChart3, AlertTriangle } from 'lucide-react';
import ComparisonChart from '@/components/report/ComparisonChart';
import PropertyCard from '@/components/report/PropertyCard';
import ReportSection from '@/components/report/ReportSection';

interface MarketComparisonProps {
  priceComparison: {
    name: string;
    value: number;
    isMain?: boolean;
  }[];
  pricePerSqMComparison: {
    name: string;
    value: number;
    isMain?: boolean;
  }[];
  similarProperties: any[];
  searchStrategy?: string;
}

const MarketComparison: React.FC<MarketComparisonProps> = ({ 
  priceComparison, 
  pricePerSqMComparison, 
  similarProperties,
  searchStrategy
}) => {
  const hasComparisonData = priceComparison.some(item => item.name !== 'Imóvel' && item.value > 0);
  
  return (
    <ReportSection title="Comparação com imóveis do mesmo tipo no mesmo bairro" icon={<BarChart3 size={22} />}>
      {!hasComparisonData && (
        <div className="mb-4 p-3 bg-amber-50 border border-amber-200 rounded-md flex items-center gap-2 text-sm text-amber-700">
          <AlertTriangle size={18} className="shrink-0" />
          <p>
            Não foram encontrados dados de mercado suficientes para uma comparação precisa neste bairro específico. 
            {searchStrategy === 'purpose only' && ' Estamos mostrando apenas o imóvel selecionado.'}
          </p>
        </div>
      )}
      
      <div className="grid md:grid-cols-2 gap-6 mb-8">
        <ComparisonChart 
          data={priceComparison} 
          title="Comparação de Preço Total (R$)" 
          unit="R$" 
          noDataMessage="Sem dados comparativos disponíveis"
        />
        <ComparisonChart 
          data={pricePerSqMComparison} 
          title="Comparação de Preço por m² (R$)" 
          unit="R$/m²" 
          noDataMessage="Sem dados comparativos disponíveis"
        />
      </div>
      
      {similarProperties && similarProperties.length > 0 ? (
        <div>
          <h3 className="text-lg font-medium mb-4">Imóveis Similares no mesmo Bairro</h3>
          <div className="grid md:grid-cols-3 gap-4">
            {similarProperties.map(property => (
              <PropertyCard key={property.id} property={property} />
            ))}
          </div>
        </div>
      ) : (
        <div className="text-center py-4 text-gray-500">
          <p>Não foram encontrados imóveis similares para comparação.</p>
          <p className="text-sm mt-1 text-gray-400">
            Isso pode ocorrer quando o imóvel está em um bairro onde não conseguimos encontrar propriedades semelhantes suficientes.
          </p>
        </div>
      )}
    </ReportSection>
  );
};

export default MarketComparison;
